import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from '@/components';

interface Tab {
  to: string;
  end?: boolean;
  icon: IconName;
  label: string;
}

/**
 * Mobile chrome for the instructor/admin consoles: a condensed top bar plus
 * a bottom tab bar exposing the most-used sections. The console's deeper
 * pages remain reachable; this gives the phone UX a native shape rather than
 * shrinking the desktop sidebar.
 */
export function MobileConsoleScaffold({ tabs, children }: { tabs: Tab[]; children: ReactNode }) {
  return (
    <div style={{ minHeight: '100dvh', background: 'var(--paper)', display: 'flex', flexDirection: 'column' }}>
      <main style={{ flex: 1, minHeight: 0, paddingBottom: 84 }}>{children}</main>
      <nav
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 40,
          background: 'var(--card)',
          borderTop: '1px solid var(--line)',
          padding: '10px 8px calc(12px + env(safe-area-inset-bottom))',
          display: 'grid',
          gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
        }}
      >
        {tabs.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end} className="wp-tab">
            {({ isActive }) => (
              <>
                <Icon name={it.icon} size={23} stroke={isActive ? 2 : 1.6} />
                <span style={{ fontSize: 10.5, fontWeight: isActive ? 600 : 500 }}>{it.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
